<template>
  <div>
    <van-nav-bar title="抽样患者评分" left-arrow @click-left="onClickLeft" />
    <div>
      <div class="qualityBox">
        <el-form ref="form" :model="controlContent" class="qcFrom" :inline="true">
          <div id="collspse">
            <el-form ref="formcoll" :model="collspsemodel" class="qcFrom collspseFrom" :inline="true">
              <el-collapse v-model="activeName" accordion>
                <el-collapse-item name="1">
                  <template v-slot:title>
                    <svg-icon class="svgImg" icon-class="lab_1"></svg-icon>
                    <span class="title">患者信息</span>
                  </template>
                  <div style="display: flex">
                    <el-row>
                      <el-col :span="12" v-for="(item, index) in reportListinfo.PadPatientInfoDto" :key="index">
                        <!-- v-if="item.Name !== '报告得分'&&item.Name !== '影像得分'" -->
                        <el-form-item class="radstart" v-if="item.Name !== '报告得分' && item.Name !== '影像得分'" :label="item.Name" >
                          <el-input
                            v-if="item.Type != 'date'"
                            v-model="item.Value"
                            class="name"
                            :placeholder="'请输入' + item.Name"
                            size="mini"
                          ></el-input>
                          <el-date-picker
                            v-else
                            type="date"
                            v-model="item.Value"
                            placeholder="选择日期时间"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="2">
                  <template v-slot:title>
                    <svg-icon class="svgImg" icon-class="lab_3"></svg-icon>
                    <span class="title">报告部分</span>
                    <!-- <span class="scorelabel">总分6分</span> -->
                  </template>
                  <div v-for="(item, index) in reportListinfo.PadReportDto" :key="index" style="margin-top:20px">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item :label="item.ScoreName + '(标准评分: ' + item.CriterionPoint + ')'">
                          <el-select v-model="item.AvailablePointCheck" placeholder="请选择" @change="reportScore()">
                            <el-option label="不扣分" :value="0"></el-option>
                            <el-option
                              v-for="(items, indexs) in item.AvailablePoint"
                              :key="indexs"
                              :label="items"
                              :value="items"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <textarea
                          name=""
                          id=""
                          cols="40"
                          rows="4"
                          class="coltextarea"
                          v-html="item.ViewMode + item.MarkingScheme"
                        ></textarea>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col id="sceneremarks">
                        <el-form-item label="备注">
                          <el-input class="sceneremarks" v-model="item.Note" size="mini" value=""></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col>
                        <el-upload
                          class="upload-demo marb18"
                          :action="fileUpload"
                          :headers="{ 'Content-Type': 'application/octet-stream' }"
                          accept="image/jpeg,image/png,image/gif,image/jpg"
                          :before-upload="beforeAvatarUpload"
                          :show-file-list="false"
                          :limit="10"
                          :auto-upload="false"
                          :on-change="getFile"
                          :on-error="handleError"
                        >
                          <i class="el-icon-plus avatar-uploader-icon" @click="getappealIndex(index, 0)"></i>
                        </el-upload>
                        <ul class="imgList">
                          <li v-for="(imgitem, imgindex) in item.Url" :key="imgindex" class="marr15">
                            <div class="deleteImg" @click="deleteImg(index, imgindex)">
                              <i class="iconfont el-icon-close"></i>
                            </div>
                            <img
                              class="drawerImg"
                              @click="handlePictureCardPreview(imgitem)"
                              :src="imgitem.Path"
                              alt=""
                            />
                          </li>
                        </ul>
                      </el-col>
                    </el-row>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="3">
                  <template v-slot:title>
                    <svg-icon class="svgImg" icon-class="lab_4"></svg-icon>
                    <span class="title">影像部分</span>
                    <!-- <span class="scorelabel">总分13分</span> -->
                  </template>
                  <div v-for="(item, index) in reportListinfo.PadImagesDto" :key="index" style="margin-top:20px">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item :label="item.ScoreName + '(标准评分: ' + item.CriterionPoint + ')'">
                          <el-select v-model="item.AvailablePointCheck" placeholder="请选择" @change="imageScore">
                            <el-option :key="0" label="不扣分" :value="0"></el-option>
                            <el-option
                              v-for="items in item.AvailablePoint"
                              :key="items"
                              :label="items"
                              :value="items"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <textarea
                          name=""
                          id=""
                          cols="40"
                          rows="4"
                          class="coltextarea"
                          v-html="item.ViewMode + item.MarkingScheme"
                        ></textarea>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col id="sceneremarks">
                        <el-form-item label="备注">
                          <el-input class="sceneremarks" v-model="item.Note" size="mini" value=""></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col>
                        <el-upload
                          class="upload-demo marb18"
                          action="#"
                          accept="image/jpeg,image/png,image/gif,image/jpg"
                          :before-upload="beforeAvatarUpload"
                          :show-file-list="false"
                          :limit="10"
                          :auto-upload="false"
                          :on-change="getFile"
                          :on-error="handleError"
                        >
                          <i class="el-icon-plus avatar-uploader-icon" @click="getappealIndex(index, 1)"></i>
                        </el-upload>
                        <ul class="imgList">
                          <li v-for="(imgitem, imgindex) in item.Url" :key="imgindex" class="marr15">
                            <div class="deleteImg" @click="deleteImg(index, imgindex)">
                              <i class="iconfont el-icon-close"></i>
                            </div>
                            <img
                              class="drawerImg"
                              @click="handlePictureCardPreview(imgitem.Path)"
                              :src="imgitem.Path"
                              alt=""
                            />
                          </li>
                        </ul>
                      </el-col>
                    </el-row>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </el-form>
          </div>
          <div class="footerBtn" v-if="btntype">
            <el-button type="primary" class="marl20" @click="determine">确定</el-button>
          </div>
        </el-form>
      </div>
      <el-dialog :visible.sync="visible"><img width="100%" :src="dialogImageUrl" alt="" /></el-dialog>
    </div>
  </div>
</template>
<script>
import Api from '@/api/index.js'
import axios from '@/js/api';
export default {
  data() {
    return {
      controlContent: {
        way: false,
        standard: false,
      },
      collspsemodel: {},
      activeName: "1",
      options: [1, 2, 3, 5],
      tableData: [{}],
      file: {
        url: "",
      },
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      imageList: [],
      appealList: [],
      fileList: [],
      imgType: false,
      value1: "",
      value: "",
      reportIndex: 0,
      imageIndex: 0,
      type: 0,
      formRules:{},
      btntype:false,
      fileUpload:Api.api.pad.uploadImage,
      visible:false
    };
  },
  computed: {
    ...Vuex.mapState("common", ["reportListinfo"]),
  },
  created() {
    this.$nextTick(()=>{
      if (this.$route.query.index !== undefined) {
          this.setreportListinfos(this.$route.query.index)
          this.btntype = false
          this.$forceUpdate()
      }else{
          this.btntype = true
          this.getReportList();
          if (this.$route.query.UniqueId) {
            this.btntype = false
          }
      }
    })
  },
  methods: {
    ...Vuex.mapMutations("common", ["setsamplingScore","setreportListinfos"]),
    ...Vuex.mapActions("common", ["getReportList"]),
    determine() {
      for (let i = 0; i < this.reportListinfo.PadPatientInfoDto.length; i++) {
        const item = this.reportListinfo.PadPatientInfoDto[i];
        if (!item.Value) {
          this.$message.error(item.Name + "不能为空");
          return false;
        }
      }
      this.setsamplingScore(this.reportListinfo);
      if (this.$route.query.UniqueId || this.$route.query.Uuid) {
        this.$route.query.state = 2
        this.$router.push({ path: "/recordDetail", query: {...this.$route.query,...{ index: 88 }} });
      }else{
        this.$router.push({ path: "/recordDetail", query: { index: 88 } });
      }

    },
    reportScore() {
      let num = 0;
      let arr = this.reportListinfo.PadReportDto;
      const targetindex = this.reportListinfo.PadPatientInfoDto.findIndex((v) => v.Name === "报告得分");
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];
        num += element.AvailablePointCheck;
      }
      let qcScores = 100 - num;
      this.reportListinfo.PadPatientInfoDto[targetindex].Value = 0;
      this.reportListinfo.PadPatientInfoDto[targetindex].Value = qcScores <= 0 ? 0 : qcScores;
    },
    imageScore() {
      let num = 0;
      let arr = this.reportListinfo.PadImagesDto;
      const targetindex = this.reportListinfo.PadPatientInfoDto.findIndex((v) => v.Name === "影像得分");
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];
        num += element.AvailablePointCheck;
      }
      let qcScores = 100 - num;
      this.reportListinfo.PadPatientInfoDto[targetindex].Value = 0;
      this.reportListinfo.PadPatientInfoDto[targetindex].Value = qcScores <= 0 ? 0 : qcScores;
    },
    getappealIndex(index, type) {
      this.reportIndex = index;
      this.type = type;
    },
    deleteImg(index, imgindex) {
      if (this.type == 0) {
        this.reportListinfo.PadReportDto[this.reportIndex].Url.splice(imgindex, 1);
      } else {
        this.reportListinfo.PadImagesDto[this.reportIndex].Url.splice(imgindex, 1);
      }
      this.$forceUpdate();
    },
    getFile(file, fileList) {
      let _this =this;
      let index = this.reportIndex;
      const formData = new FormData();
      formData.append("file", file.raw);
      axios
        .uploadPost("post", Api.api.pad.uploadImage, formData, {
          "Content-Type": "multipart/form-data; boundary=" + file.uid,
        })
        .then((res) => {
          if (_this.type == 0) {
            _this.reportListinfo.PadReportDto[index].Url.push({
              Path: res.data.Data,
            });
          }else{
            _this.reportListinfo.PadImagesDto[index].Url.push({
              Path: res.data.Data,
            });
          }

            _this.$forceUpdate();
        });
    },
    handleUploadRemove(file, fileList) {
      this.proofImage = "";
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 1;
      let fname = file.name.toUpperCase();
      if (fname.match("JPG|PNG|JPEG") == null) {
        this.$message.error("上传图片需要JPG或者PNG格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 1MB!");
      }
      return isLt2M;
    },
    handleAvatarSuccess(res, file) {},
    handleError(err, rawFile) {
      // this.$message.error('图片上传错误');
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.Path;
      this.visible = true;
    },
    handleRemove(file) {
      console.log(file);
    },
    handleDownload(file) {
      console.log(file);
    },
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.footerBtn {
  position: fixed;
  bottom: 5px;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  .el-button {
    width: 120px;
    height: 40px;
    border-radius: 6px;
  }
}
.marl20 {
  margin-left: 20px;
}
.qualityBox {
  padding: 20px;
  margin: 16px;
}
</style>
